import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-800 dark:text-slate-200 flex flex-col justify-center pt-24 pb-16 px-4 transition-colors duration-300"
    >
      <div className="max-w-5xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            Sobre mí
          </h2>
          <div className="w-24 h-1 bg-blue-600 dark:bg-blue-500 mx-auto mb-4"></div>
          <p className="text-lg text-slate-600 dark:text-slate-300 max-w-2xl mx-auto">
            Desarrollador Full Stack apasionado por crear soluciones
            tecnológicas innovadoras
          </p>
        </div>

        {/* Main Content */}
        <div className="grid md:grid-cols-1 gap-8">
          {/* Presentación Principal */}
          <div className="bg-white dark:bg-slate-800 rounded-xl p-6 md:p-8 shadow-lg border border-slate-200 dark:border-slate-700 transition-all duration-300 hover:shadow-xl">
            <div className="space-y-5">
              <p className="text-lg leading-relaxed text-slate-700 dark:text-slate-300">
                Soy{" "}
                <span className="font-semibold text-blue-600 dark:text-blue-400">
                  Desarrollador Full Stack
                </span>{" "}
                especializado en crear sistemas de gestión con{" "}
                <span className="font-semibold text-blue-600 dark:text-blue-400">
                  integraciones complejas
                </span>{" "}
                (AFIP, pasarelas de pago, autenticación de roles). Con{" "}
                <strong>2+ años de experiencia real</strong> desarrollando
                soluciones para clientes comerciales.
              </p>

              <p className="text-lg leading-relaxed text-slate-700 dark:text-slate-300">
                <strong className="text-blue-600 dark:text-blue-400">
                  Mi trayectoria:
                </strong>
                <br />• <strong>2022</strong> - Graduado de Henry (800 horas
                intensivas, metodologías ágiles)
                <br />• <strong>2023</strong> - Primeros proyectos freelance y
                e-commerce completo
                <br />• <strong>2024-presente</strong> - 6+ proyectos
                comerciales (colegios, empresas, inmobiliarias)
                <br />• <strong>2025-presente</strong> - Cursando Tecnicatura en
                Desarrollo de Software (Universidad Nacional de Catamarca)
              </p>

              <p className="text-lg leading-relaxed text-slate-700 dark:text-slate-300">
                He desarrollado desde cero sistemas que{" "}
                <span className="font-semibold text-blue-600 dark:text-blue-400">
                  gestionan 500+ usuarios, procesan 600+ transacciones mensuales
                  automáticas
                </span>
                , y reducen tiempos operativos hasta 70%. Mi experiencia abarca
                desde arquitectura de base de datos hasta{" "}
                <span className="font-semibold text-blue-600 dark:text-blue-400">
                  deployment completo en servidores VPS
                </span>{" "}
                (Ubuntu, PM2, Nginx) llevando proyectos de desarrollo a
                producción.
              </p>

              <p className="text-lg leading-relaxed text-slate-700 dark:text-slate-300">
                Destaco en{" "}
                <span className="font-semibold text-blue-600 dark:text-blue-400">
                  equipos colaborativos con metodologías ágiles
                </span>
                . Me motiva resolver problemas reales del negocio con código
                limpio, escalable y bien documentado.
              </p>
            </div>
          </div>

          {/* Lo que busco */}
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-slate-800 dark:to-slate-700 border border-blue-200 dark:border-blue-900 rounded-xl p-6 md:p-8 shadow-lg transition-all duration-300 hover:shadow-xl">
            <div className="flex items-center mb-6">
              <div className="bg-blue-600 dark:bg-blue-500 rounded-full p-2.5 mr-3 shadow-md">
                <svg
                  className="w-6 h-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 dark:text-white">
                Lo que busco
              </h3>
            </div>

            <ul className="space-y-4">
              <li className="flex items-start text-slate-800 dark:text-slate-200">
                <div className="bg-blue-600 dark:bg-blue-500 rounded-full p-1.5 mr-3 mt-0.5 flex-shrink-0 shadow-sm">
                  <svg
                    className="w-3.5 h-3.5 text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <span className="text-base">
                  Nuevas oportunidades como{" "}
                  <strong className="text-blue-700 dark:text-blue-300">
                    Desarrollador Full Stack
                  </strong>{" "}
                  donde pueda aportar mi experiencia y seguir creciendo
                  profesionalmente
                </span>
              </li>

              <li className="flex items-start text-slate-800 dark:text-slate-200">
                <div className="bg-blue-600 dark:bg-blue-500 rounded-full p-1.5 mr-3 mt-0.5 flex-shrink-0 shadow-sm">
                  <svg
                    className="w-3.5 h-3.5 text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <span className="text-base">
                  Proyectos desafiantes con{" "}
                  <strong className="text-blue-700 dark:text-blue-300">
                    tecnologías modernas
                  </strong>{" "}
                  y buenas prácticas de desarrollo
                </span>
              </li>

              <li className="flex items-start text-slate-800 dark:text-slate-200">
                <div className="bg-blue-600 dark:bg-blue-500 rounded-full p-1.5 mr-3 mt-0.5 flex-shrink-0 shadow-sm">
                  <svg
                    className="w-3.5 h-3.5 text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <span className="text-base">
                  Equipos colaborativos con{" "}
                  <strong className="text-blue-700 dark:text-blue-300">
                    metodologías ágiles
                  </strong>{" "}
                  y cultura de aprendizaje continuo
                </span>
              </li>

              <li className="flex items-start text-slate-800 dark:text-slate-200">
                <div className="bg-blue-600 dark:bg-blue-500 rounded-full p-1.5 mr-3 mt-0.5 flex-shrink-0 shadow-sm">
                  <svg
                    className="w-3.5 h-3.5 text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <span className="text-base">
                  Ambiente donde pueda{" "}
                  <strong className="text-blue-700 dark:text-blue-300">
                    contribuir con ideas
                  </strong>{" "}
                  y participar activamente en las decisiones técnicas
                </span>
              </li>
            </ul>
          </div>

          {/* Sección de Idiomas y Disponibilidad */}
          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            {/* Idiomas */}
            <div className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-lg border border-slate-200 dark:border-slate-700 transition-all duration-300 hover:shadow-xl">
              <div className="flex items-center mb-5">
                <div className="bg-blue-600 dark:bg-blue-500 rounded-full p-2.5 mr-3 shadow-md">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-900 dark:text-white">
                  Idiomas
                </h3>
              </div>

              <div className="space-y-4">
                <div>
                  <div className="flex justify-between mb-1.5">
                    <span className="font-semibold text-slate-800 dark:text-slate-200">
                      Español
                    </span>
                    <span className="text-sm text-slate-600 dark:text-slate-400">
                      Nativo
                    </span>
                  </div>
                  <div className="w-full bg-slate-200 dark:bg-slate-700 rounded-full h-2.5">
                    <div
                      className="bg-blue-600 dark:bg-blue-500 h-2.5 rounded-full"
                      style={{ width: "100%" }}
                    ></div>
                  </div>
                </div>

                <div>
                  <div className="flex justify-between mb-1.5">
                    <span className="font-semibold text-slate-800 dark:text-slate-200">
                      Inglés
                    </span>
                    <span className="text-sm text-slate-600 dark:text-slate-400">
                      Intermedio (Lectura)
                    </span>
                  </div>
                  <div className="w-full bg-slate-200 dark:bg-slate-700 rounded-full h-2.5">
                    <div
                      className="bg-blue-600 dark:bg-blue-500 h-2.5 rounded-full"
                      style={{ width: "65%" }}
                    ></div>
                  </div>
                  <p className="text-xs text-slate-500 dark:text-slate-400 mt-1.5">
                    Documentación técnica, código y tutoriales
                  </p>
                </div>
              </div>
            </div>

            {/* Disponibilidad */}
            <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-xl p-6 shadow-lg transition-all duration-300 hover:shadow-xl">
              <div className="flex items-center mb-5">
                <div className="bg-green-600 dark:bg-green-500 rounded-full p-2.5 mr-3 shadow-md">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-slate-900 dark:text-white">
                  Disponibilidad
                </h3>
              </div>

              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                  <span className="text-lg font-semibold text-green-700 dark:text-green-400">
                    Disponible inmediatamente
                  </span>
                </div>

                <ul className="space-y-2.5 ml-1">
                  <li className="flex items-start text-slate-700 dark:text-slate-300">
                    <svg
                      className="w-5 h-5 text-green-600 dark:text-green-400 mr-2 mt-0.5 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>Posición Full-Time</span>
                  </li>
                  <li className="flex items-start text-slate-700 dark:text-slate-300">
                    <svg
                      className="w-5 h-5 text-green-600 dark:text-green-400 mr-2 mt-0.5 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>Remoto o híbrido</span>
                  </li>
                  <li className="flex items-start text-slate-700 dark:text-slate-300">
                    <svg
                      className="w-5 h-5 text-green-600 dark:text-green-400 mr-2 mt-0.5 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>Proyectos freelance</span>
                  </li>
                  <li className="flex items-start text-slate-700 dark:text-slate-300">
                    <svg
                      className="w-5 h-5 text-green-600 dark:text-green-400 mr-2 mt-0.5 flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>Inicio inmediato</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
